export const labels = {
  // Panel Headers
  clientRequestTitleMissing: "Missing Title (required) Missing Title (required)",
  excelError: "Excel formula error. Fix and try again. Excel formula error. Fix and try again.",
  selectRecordsToUpdate: "Select records to update Select records to update",
  atlasWorkpaperIndexFramework: "EY Atlas: Workpaper indexing framework EY Atlas: Workpaper indexing framework",
  engagementNotSelected: "Select an engagement Select an engagement",
  entityNotSelected: "Select an option to continue Select an option to continue",
  engagement: "Engagement Engagement",
  select: "Select Select",
  numberOfRecords: "Number of records Number of records",
  dowanloadedOn: "Downloaded on Downloaded on",
  canvasUpdatesOn: "Sent to EY Canvas for processing Sent to EY Canvas for processing",
  invalidColumn: "Invalid data in {0} Invalid data in {0}",
  requiredColumn: "{0} is required {0} is required",
  userNotFromSelectedGroup:
    "Request cannot be assigned to both a group and user Request cannot be assigned to both a group and user",
  hashValueMissing:
    "Hash value needed to update EY Canvas. Check column in this worksheet. Hash value needed to update EY Canvas. Check column in this worksheet.",
  dueDateFormatError: "Invalid date format in Due date Invalid date format in Due date",
  dummyLocalizationText: "Dummy Localization Text",
  unexpectedApiFailure: "Unexpected API failure. Please try again.",
  canvasDataEditor: "Canvas data editor",
  selectanitemtoedit: "Select an option Select an option",
  sheetWithSameNameExist: "A sheet named Input_sheet_{0} already exists. Please rename the sheet to continue.",
  engagementIdNotFound:
    "Could not find the EY Canvas engagement. Check the Engagement ID and confirm you have access to open the EY Canvas engagement.",
  boundSheetAlreadyExist_1: "EY Canvas Bulk Update Add-in EY Canvas Bulk Update Add-in",
  boundSheetAlreadyExist_2: "does not work on this tab does not work on this tab",
  infoText1:
    "Edit EY Canvas document and task names for Standardized Indexing, and Edit EY Canvas document and task names for Standardized Indexing, and",
  infoText3: "Create and edit other items in EY Canvas Create and edit other items in EY Canvas",
  infoTextforonlyAddClientRequest: "Create client requests Create client requests",
  masterSheetNoteText:
    "Note: This sheet is required to use EY Canvas Bulk Update Add-in. Note: This sheet is required to use EY Canvas Bulk Update Add-in.",
  selectAnOperation: "What would you like to do? What would you like to do?",
  submit: "Submit Submit",
  next: "Next Next",
  eyCanvasEngagement: "Select an engagement Select an engagement",
  search: "Search Search",
  invalidEngagement: "Select a valid engagement",
  back: "Back Back",
  noRecordsFound: "No records found No records found",
  editRequestMessage: "Which requests would you like to edit? Which requests would you like to edit?",
  selectRequestStatus: "Select at least one request status Select at least one request status",
  selectRequestErrorMessage: "Select at least one request status Select at least one request status",
  help: "Help Help",
  infoText:
    "You cannot run EY Canvas Bulk Update Add-in on multiple sheets in the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook. You cannot run EY Canvas Bulk Update Add-in on multiple sheets in the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook.",
  noUpdatesSaved: "No updates saved No updates saved",
  informationText:
    "This tool allows you to edit EY Canvas document and task names for Standardized Indexing, and edit and upload new draft Collaboration requests using Excel. This tool allows you to edit EY Canvas document and task names for Standardized Indexing, and edit and upload new draft Collaboration requests using Excel.",
  yes: "Yes Yes",
  no: "No No",
  close: "Close",
  ownedByEngagement: "Owned by this engagement",
  sharedToEngagement: "Shared into this engagement",
  dueDateRequired: "Due date required Due date required",
  requestNotAssignedError: "Assign the request to a group or user Assign the request to a group or user",
  status: "Status Status",
  statusId: "Status id Status id",
  titleLengthExceeded: "Title exceeds 500 character limit Title exceeds 500 character limit",
  DescriptionLengthExceeded: "Description exceeds 4000 character limit Description exceeds 4000 character limit",
  updateCanvas: "Update EY Canvas Update EY Canvas",
  newDocumentName: "New document name",
  documentName: "Document name",
  fileExt: "File extension",
  referenceOnly: "Reference only Reference only",
  columnsToUpdate: "Update these columns Update these columns",
  shared: "Shared",
  docId: "Document Id",
  hash: "Hash Hash",
  newPrefix: "New prefix",
  Continue: "Continue Continue",
  newSuffix: "New suffix",
  newTitle: "New title",
  taskPrefix: "Task prefix",
  taskSuffix: "Task suffix",
  taskTitle: "Title Title",
  taskType: "Task type Task type",
  taskTitleEditable: "Task title editable",
  auditPhase: "Audit Phase Audit Phase",
  milestone: "Milestone Milestone",
  timePhase: "Time Phase Time Phase",
  taskId: "Task Id Task Id",
  APIValidationError:
    "Some records could not be updated in EY Canvas. Check the<b> Status </b>column for details. Some records could not be updated in EY Canvas. Check the<b> Status </b>column for details.",
  offlineModeUserClickError:
    "Opening the EY Canvas Bulk Update Add-in was interrupted when you clicked on an Excel worksheet. To try again, close and re-open the EY Canvas Bulk Update Add-in. Opening the EY Canvas Bulk Update Add-in was interrupted when you clicked on an Excel worksheet. To try again, close and re-open the EY Canvas Bulk Update Add-in.",
  errorMessageOnExcelUpdate:
    "Could not update EY Canvas, as some records had errors. Check the<b> Status </b>column for details. Could not update EY Canvas, as some records had errors. Check the<b> Status </b>column for details.",
  inActiveWorkbookError:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again. To prevent this error in the future, avoid switching workbooks while data is populating. An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again. To prevent this error in the future, avoid switching workbooks while data is populating.",
  addclinetRequestTagError:
    "Request created in EY Canvas but tags could not be added. You can manually add the tags in EY Canvas. Request created in EY Canvas but tag could not be added. You can manually add the tags in EY Canvas.",
  editclinetRequestTagError:
    "Tags could not be edited for this request. You can manually add or remove tags in EY Canvas. Tags could not be edited for this request. You can manually add or remove tags in EY Canvas.",
  excelPopulatingMessage:
    "Populating Excel. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading. Populating Excel. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading.",
  clinetRequestEYContactError:
    "EY contacts could not be edited for this request. You can manually add or remove EY contacts in EY Canvas.",
  genericErrorMessage:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again. An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again.",
  itgcName: "ITGC name (required) ITGC name (required)",
  misstatementIndex: "Misstatement index (required) Misstatement index (required)",
  misstatementDescription: "Misstatement description (required) Misstatement description (required)",
  misstatementId: "Misstatement ID Misstatement ID",
  frequency: "Frequency Frequency",
  designEffectiveness: "Design effectiveness Design effectiveness",
  operatingEffectiveness: "Operating effectiveness Operating effectiveness",
  testing: "Testing Testing",
  itControlId: "IT Control ID IT Control ID",
  controlName: "Control name (required) Control name (required)",
  controlType: "Control type Control type",
  controlId: "Control ID Control ID",
  isControlLowerRisk: "Is control lower risk? Is control lower risk?",
  timePhaseName: "Time phase name (required) Time phase name (required)",
  milestoneRequired: "Milestone (required) Milestone (required)",
  startDate: "Start date (YYYY-MM-DD) (required) Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required) End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event Key event",
  timePhaseId: "Time phase ID Time phase ID",
  startDateFormatError: "Invalid date format in Start date Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date Invalid date format in End date",
  deficiencyTitle: "Deficiency name (required) Deficiency name (required)",
  deficiencyDescription: "Deficiency description (required) Deficiency description (required)",
  deficiencyCategory: "Deficiency relates to Deficiency relates to",
  deficiencyId: "Deficiency ID Deficiency ID",
  prefix: "Prefix Prefix",
  suffix: "Suffix Suffix",
  requiredTitle: "Title (required) Title (required)",
  timePhaseRequired: "Time phase (required) Time phase (required)",
  taskGroupRequired: "Task group (required) Task group (required)",
  customizedDescription: "Customized description Customized description",
  customizedDescriptionRequired: "Customized description (required) Customized description (required)",
  picSignOffRequired: "PIC sign-off PIC sign-off",
  eqrSignOffRequired: "EQR sign-off EQR sign-off",
  invalidDataInTags: "Invalid data in Tags Invalid data in Tags",
  taskGroups: "Task group Task group",
  taskTags: "Tags Tags",
  taskTitleRequiredError: "Task title is required Task title is required",
  editTaskAPIError: "Tags could not be edited for this task. You can manually add or remove tags in EY Canvas. Tags could not be edited for this task. You can manually add or remove tags in EY Canvas.",
  engagementLDCVersionUpdateError: "An update is available for EY Canvas Bulk Update Add-in. Open the add-in in a new workbook to save changes to task names. An update is available for EY Canvas Bulk Update Add-in. Open the add-in in a new workbook to save changes to task names.",
  module: "Module Module",
  titleForMultiSelectInputMessage: "Multi-select dropdown Multi-select dropdown",
  descriptionForMultiSelectInputMessage: "Select one or more dropdown options using the add-in pane on the right. Select one or more dropdown options using the add-in pane on the right.",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "This tool can be used to bulk edit client requests in EY Canvas Collaboration. This tool can be used to bulk edit client requests in EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration. Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo: "\u00B9 This is multi-select dropdown field. To edit this field, use the dropdown on the add-in pane on the right. \u00B9 This is multi-select dropdown field. To edit this field, use the dropdown on the add-in pane on the right.",
  bulkUpdate:
    "\u00B2 See Additional instructions \u00B2 See Additional instructions",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "This tool can be used to bulk upload new tasks (OSTs) to EY Canvas. This tool can be used to bulk upload new tasks (OSTs) to EY Canvas.",
  guidanceHyperlink: "EY Atlas EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas. Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas.",
  additionalInfo: "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right. \u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas \r\nUpdate EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toSaveAsDraft: "Yes Yes",
    toSendToClient: "N/A N/A",
  },
  {
    count: "2 2",
    fieldName: "Title Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests. Develop a naming convention that will help you efficiently manage all Requests.",
    toSaveAsDraft: "Yes Yes",
    toSendToClient: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Description Description",
    additionalInstructions: "The Description has a 4,000 character limit The Description has a 4,000 character limit",
    toSaveAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "4 4",
    fieldName: "Assigned to (group) Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option. \r\nAssign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toSaveAsDraft: "No No",
    toSendToClient: "One of these is required One of these is required",
  },
  {
    count: "5 5",
    fieldName: "Assigned to (user) Assigned to (user)",
    additionalInstructions: "",
    toSaveAsDraft: "No No",
    toSendToClient: "",
  },
  {
    count: "6 6",
    fieldName: "Due date (YYYY-MM-DD) Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase. Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toSaveAsDraft: "No No",
    toSendToClient: "Yes \u00B2 Yes \u00B2",
  },
  {
    count: "7 7",
    fieldName: "EY contact \u00B9 EY contact \u00B9",
    additionalInstructions:
      "Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the request. Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the request.",
    toSaveAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "8 8",
    fieldName: "Tags \u00B9 Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically. Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically.",
    toSaveAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "9 9",
    fieldName: "Priority Priority",
    additionalInstructions:
      "Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal. Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal.",
    toSaveAsDraft: "No No",
    toSendToClient: "Yes \u00B2 Yes \u00B2",
  },
  {
    count: "10 10",
    fieldName: "Time phase Time phase",
    additionalInstructions:
      "Select a Time phase and/or Due date (see above). Select a Time phase and/or Due date (see above).",
    toSaveAsDraft: "No No",
    toSendToClient: "No No",
  },
];

export const instructionSheetHeader = {
  // reference sheet columns
  count: "# #",
  fieldName: "Field Name Field Name",
  additionalInstructions: "Additional instructions Additional instructions",
  toUploadAsDraft: "To upload as Draft To upload as Draft ",
  toSendToClient: "To send to client To send to client ",
  bulkUpdateAddIn: "EY Canvas Bulk Update Add-in EY Canvas Bulk Update Add-in",
  purpose: "Purpose Purpose",
  guidance: "Guidance Guidance",
  overView: "Overview of fields Overview of fields ",
  required: "Required Required",
  toSaveAsDraft: "To save as Draft To save as Draft",
};
export const instructionSheetDataForEditTasks = {
  purpose:
    "This tool can be used to bulk edit tasks in EY Canvas. This tool can be used to bulk edit tasks in EY Canvas.",
  guidanceHyperlinkforStandardizedIndexing: "Standardized Indexing Standardized Indexing",
  guidanceforStandardizedIndexing:
    "This tool can be used to facilitate Standardized Indexing for tasks. Refer to the EY Atlas guidance link for details on Standardized Indexing. This tool can be used to facilitate Standardized Indexing for tasks. Refer to the EY Atlas guidance link for details on Standardized Indexing.",
  guidanceHyperlinkForTaskAssignments: "Task assignments Task assignments",
  guidanceForTaskAssignments:
    "Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas. Refer to the EY Atlas link for additional guidance on Task assignments in EY Canvas, including how to bulk assign tasks in EY Canvas.",
  additionalInfo: "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right. \u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "Prefix Prefix",
    additionalInstructions:
      "Use a prefix to support a naming convention for Standardized Indexing (50 character limit) Use a prefix to support a naming convention for Standardized Indexing (50 character limit)",
    required: "No No",
  },
  {
    count: "3 3",
    fieldName: "Title Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage your tasks (500 character limit) Develop a naming convention that will help you efficiently manage your tasks (500 character limit)",
    required: "Yes Yes",
  },
  {
    count: "4 4",
    fieldName: "Suffix Suffix",
    additionalInstructions: "50 character limit 50 character limit",
    required: "No No",
  },
  {
    count: "5 5",
    fieldName: "Time phase Time phase",
    additionalInstructions:
      "Assign tasks to time phases to support effective project management Assign tasks to time phases to support effective project management",
    required: "Yes Yes",
  },
  {
    count: "6 6",
    fieldName: "Task group Task group",
    additionalInstructions:
      "Organize audit work into manageable groups of tasks. Task groups can only be edited for OSTs. Organize audit work into manageable groups of tasks. Task groups can only be edited for OSTs.",
    required: "Yes Yes",
  },
  {
    count: "7 7",
    fieldName: "Customized description Customized description",
    additionalInstructions:
      "Describe the procedures to be performed for this task Describe the procedures to be performed for this task",
    required: "No No",
  },
  {
    count: "8 8",
    fieldName: "Tags \u00B9 Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in EY Canvas that can assist in managing tasks Tags are custom labels available in EY Canvas that can assist in managing tasks",
    required: "No No",
  },
  {
    count: "9 9",
    fieldName: "PIC sign-off PIC sign-off",
    additionalInstructions:
      "Indicate whether the task requires PIC sign-off. (Cannot be edited if PIC sign-off is designated from Knowledge.) Indicate whether the task requires PIC sign-off. (Cannot be edited if PIC sign-off is designated from Knowledge.)",
    required: "No No",
  },
  {
    count: "10 10",
    fieldName: "EQR sign-off EQR sign-off",
    additionalInstructions:
      "Indicate whether the task requires EQR sign-off. (Cannot be edited if EQR sign-off is designated from Knowledge.) Indicate whether the task requires EQR sign-off. (Cannot be edited if EQR sign-off is designated from Knowledge.)",
    required: "No No",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose:
    "This tool can be used to bulk edit ITGC details in EY Canvas. This tool can be used to bulk edit ITGC details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted. \u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};

export const instructionSheetTabularDataITGC = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "ITGC name (required) ITGC name (required)",
    additionalInstructions: "ITGC name has a 500 character limit ITGC name has a 500 character limit",
    required: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Frequency Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list Select a control frequency from the drop-down list",
    required: "No\u002A No\u002A",
  },
  {
    count: "4 4",
    fieldName: "Design effectiveness Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective) If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No No",
  },
  {
    count: "5 5",
    fieldName: "Operating effectiveness Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective) If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No No",
  },
  {
    count: "6 6",
    fieldName: "Testing Testing",
    additionalInstructions: "Indicate if we plan to test this control Indicate if we plan to test this control",
    required: "No No",
  },
];

export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas. This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted. \u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences. Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};

export const instructionSheetTabularDataMisstatement = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in:\r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in:\r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "Misstatement index Misstatement index",
    additionalInstructions:
      "Unique identifier for the misstatement (100 character limit) Unique identifier for the misstatement (100 character limit)",
    required: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Misstatement description Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit) Description of the misstatement (500 character limit)\n",
    required: "Yes Yes",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "This tool can be used to bulk upload new tasks (OSTs) to EY Canvas. This tool can be used to bulk upload new tasks (OSTs) to EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas, it can be changed but not deleted. \u002AIf a value is already specified in EY Canvas, it can be changed but not deleted.",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "Prefix Prefix",
    additionalInstructions:
      "Use a prefix to support a naming convention for Standardized Indexing (50 character limit) Use a prefix to support a naming convention for Standardized Indexing (50 character limit)",
    required: "No No",
  },
  {
    count: "3 3",
    fieldName: "Title Title",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage your tasks (500 character limit) Develop a naming convention that will help you efficiently manage your tasks (500 character limit)",
    required: "Yes Yes",
  },
  {
    count: "4 4",
    fieldName: "Suffix Suffix",
    additionalInstructions: "50 character limit 50 character limit",
    required: "No No",
  },
  {
    count: "5 5",
    fieldName: "Time phase Time phase",
    additionalInstructions:
      "Assign tasks to time phases to support effective project management Assign tasks to time phases to support effective project management ",
    required: "Yes Yes",
  },
  {
    count: "6 6",
    fieldName: "Task group Task group",
    additionalInstructions:
      "Organize work into manageable groups of tasks Organize work into manageable groups of tasks",
    required: "Yes Yes",
  },
  {
    count: "7 7",
    fieldName: "Customized description Customized description",
    additionalInstructions:
      "Describe the procedures to be performed for this task Describe the procedures to be performed for this task",
    required: "Yes Yes",
  },
  {
    count: "8 8",
    fieldName: "Tags \u00B9 Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in EY Canvas that can assist in managing tasks Tags are custom labels available in EY Canvas that can assist in managing tasks",
    required: "No No",
  },
  {
    count: "9 9",
    fieldName: "PIC sign-off PIC sign-off",
    additionalInstructions:
      "Indicate whether the task requires PIC sign-off Indicate whether the task requires PIC sign-off",
    required: "No No",
  },
  {
    count: "10 10",
    fieldName: "EQR sign-off EQR sign-off",
    additionalInstructions:
      "Indicate whether the task requires EQR sign-off Indicate whether the task requires EQR sign-off",
    required: "No No",
  },
];

export const instructionSheetData = {
  purpose:
    "This tool can be used to bulk upload new client requests to EY Canvas Collaboration. Requests will be uploaded in 'Draft' status. You can then bulk send requests to the client from EY Canvas Collaboration. This tool can be used to bulk upload new client requests to EY Canvas Collaboration. Requests will be uploaded in 'Draft' status. You can then bulk send requests to the client from EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration. Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo: "\u00B2 See Additional instructions \u00B2 See Additional instructions",
  bulkUpdate:
    "\u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right. \u00B9 This is a multi-select dropdown field. To edit this field, use the dropdown in the add-in pane on the right.",
};

export const instructionSheetTabularData = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas \r\n When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toUploadAsDraft: "Yes Yes",
    toSendToClient: "N/A N/A",
  },
  {
    count: "2 2",
    fieldName: "Title (required) Title (required)",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests. Develop a naming convention that will help you efficiently manage all Requests.",
    toUploadAsDraft: "Yes Yes",
    toSendToClient: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Description Description",
    additionalInstructions: "The Description has a 4,000 character limit The Description has a 4,000 character limit",
    toUploadAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "4 4",
    fieldName: "Assigned to (group) Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option. Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toUploadAsDraft: "No No",
    toSendToClient: "One of these is required One of these is required",
  },
  {
    count: "5 5",
    fieldName: "Assigned to (user) Assigned to (user)",
    additionalInstructions: "",
    toUploadAsDraft: "No No",
    toSendToClient: "",
  },
  {
    count: "6 6",
    fieldName: "Due date (YYYY-MM-DD) Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase. Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toUploadAsDraft: "No No",
    toSendToClient: "Yes \u00B2 Yes \u00B2",
  },
  {
    count: "7 7",
    fieldName: "EY contact \u00B9 EY contact \u00B9",
    additionalInstructions:
      "Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the Request. Add an EY contact to let the external user know who to contact if they have questions. The EY contact will receive a notification when the client responds to the Request.",
    toUploadAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "8 8",
    fieldName: "Tags \u00B9 Tags \u00B9",
    additionalInstructions:
      "Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically. Tags are custom labels available in Collaboration to assist in managing the requests. You can see tags applied by the team and those applied by external users. Tags will be synchronized between Collaboration and EY Canvas Client Portal automatically.",
    toUploadAsDraft: "No No",
    toSendToClient: "No No",
  },
  {
    count: "9 9",
    fieldName: "Priority Priority",
    additionalInstructions:
      "Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal. Set a Request priority of High or Critical to help your client prioritize the requests. If not specified, the Request priority will default to Normal.",
    toUploadAsDraft: "No No",
    toSendToClient: "Yes \u00B2 Yes \u00B2",
  },
  {
    count: "10 10",
    fieldName: "Time phase Time phase",
    additionalInstructions:
      "Select a Time phase and/or Due date (see above). Select a Time phase and/or Due date (see above).",
    toUploadAsDraft: "No No",
    toSendToClient: "No No",
  },
];

export const errors = {
  14057: "A document with the same name already exists in the engagement.",
  14084: 'File name cannot include: */:<>?|""',
  14085: "The document name exceeded maximum length allowed.",
  14086: "DocService failed while updating document details.",
  21039: "Assign the request to a valid group/user. Assign the request to a valid group/user",
  21032: "Assign the request to a valid group/user. Assign the request to a valid group/user",
  21034: "Client Group does not have active users Client Group does not have active users",
  21035: "Request not found in EY Canvas. Assign the request to a group or user",
  21057:
    "EY Contact is not a member of the engagement, is not Active, or is Independence-only. EY Contact is not a member of the engagement, is not Active, or is Independence-only",
  21074:
    "Cannot change Title, Description, or Priority for Received requests. Cannot change Title, Description, or Priority for Received requests",
  21075:
    "Cannot change Title, Description, Assigned to (group), Assigned to (user), Due date, Priority or Timephase for Accepted requests. Cannot change Title, Description, Assigned to (group), Assigned to (user), Due date, Priority or Timephase for Accepted requests",
  21076: "PriorityTypeId enum does not contain 1, 2 or 3. PriorityTypeId enum does not contain 1, 2 or 3",
  21077: "Specify a due date in YYYY-MM-DD format. Specify a due date in YYYY-MM-DD format",
  21078:
    "Group and User are both required, when updating either Assigned To Group or Assigned To User. Group and User are both required, when updating either Assigned To Group or Assigned To User",
  21079: "Specify a due date in YYYY-MM-DD format. Specify a due date in YYYY-MM-DD format",
  21080: "Due date is required, when Timephase is available Due date is required, when Timephase is available",
  21081: "EY Contact(s) is not valid or includes duplicates. EY Contact(s) is not valid or includes duplicates",
  25000: "Specify a time phase. Specify a time phase",
  26000: "Specify a due date in YYYY-MM-DD format. Specify a due date in YYYY-MM-DD format",
  84006: "ITGC name is required ITGC name is required",
  37007: "Misstatement index is required Misstatement index is required",
  37009: "Misstatement description is required Misstatement description is required",
  37130:
    "Misstatement description exceeds 500 character limit Misstatement description exceeds 500 character limit",
  37023: "Invalid Misstatement ID Invalid Misstatement ID",
  37036: "Invalid Misstatement ID Invalid Misstatement ID",
  37068:
    "One or more data in the request payload is not valid. Please verify the data and try again. One or more data in the request payload is not valid. Please verify the data and try again.",
  37069:
    "One or more data in the request payload is not valid. Please verify the data and try again. One or more data in the request payload is not valid. Please verify the data and try again.",
  37070:
    "One or more data in the request payload is not valid. Please verify the data and try again. One or more data in the request payload is not valid. Please verify the data and try again.",
  37072:
    "Misstatement index exceeds 100 character limit Misstatement index exceeds 100 character limit",
  37130:
    "Misstatement description exceeds 500 character limit Misstatement description exceeds 500 character limit",
  84007: "ITGC name exceeds 500 character limit. ITGC name exceeds 500 character limit",
  84008: "Invalid data in Frequency. Invalid data in Frequency",
  84029: "Invalid data in Frequency. Invalid data in Frequency",
  84010: "Invalid data in Design effectiveness. Invalid data in Design effectiveness",
  84027: "Invalid data in testing Invalid data in testing",
  84028: "Invalid data in testing. Invalid data in testing",
  84031:
    "Cannot conclude on Operating Effectiveness if Testing = No Cannot conclude on Operating Effectiveness if Testing = No",
  84032: "Invalid data in Design effectiveness Invalid data in Design effectiveness",
  84004: "Invalid IT Control ID Invalid IT Control ID",
  83018: "Control name exceeds 500 character limit Control name exceeds 500 character limit",
  83004: "Invalid Control ID Invalid Control ID",
  83006: "Control name is required Control name is required",
  83009: "Invalid data in Frequency Invalid data in Frequency",
  83010: "Invalid data in Control type Invalid data in Control type",
  83031: "Invalid data in IsIPEManuallyTested Invalid data in IsIPEManuallyTested",
  83012: "Invalid data in Design effectiveness Invalid data in Design effectiveness",
  83033: "Invalid data in Operating effectiveness Invalid data in Operating effectiveness",
  83034: "Invalid data in testing Invalid data in testing",
  36023: "Invalid Deficiency ID Invalid Deficiency ID",
  36044: "Deficiency name is required Deficiency name is required",
  36045: "Deficiency name exceeds 100 character limit Deficiency name exceeds 100 character limit",
  36005: "Deficiency description is required Deficiency description is required",
  36006: "Deficiency description exceeds 4000 character limit Deficiency description exceeds 4000 character limit",
  5169: "Prefix exceeds 50 character limit Prefix exceeds 50 character limit",
  5170: "Suffix exceeds 50 character limit Suffix exceeds 50 character limit",
  5047: "Title exceeds 500 character limit Title exceeds 500 character limit",
  5108: "Description exceeds 4000 character limit Description exceeds 4000 character limit",
  5059: "Invalid data in Time phase (required) Invalid data in Time phase (required)",
  5111: "Invalid data in Task group (required) Invalid data in Task group (required)",
  5051: "Invalid data in Task group (required) Invalid data in Task group (required)",
  5019: "Customized description (required) is required Customized description (required) is required",
  5103: "Title (required) is required Title (required) is required",
  5104: "Time phase (required) is required Time phase (required) is required",
  5109: "Task group (required) is required Task group (required) is required",
  5203: "PIC sign-off is required PIC sign-off is required",
  5204: "EQR sign-off is required EQR sign-off is required",
  5202: "Cannot change task group Cannot change task group",
  5168: "Title (required) is required Title (required) is required",
  16003: "Invalid Time phase ID Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required) Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone Invalid data in Milestone",
  16008: "Invalid data in Start date Invalid data in Start date",
  16009: "Invalid data in End date Invalid data in End date",
  16010: "Time phase name (required) is required Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01 Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date End date must be on or after the Start date",
  16024: "Key event is required Key event is required",
  16025: "Start date must be on or before the End date Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "Scope",
  2: "Strategy",
  3: "Walkthroughs",
  4: "Interim control testing",
  5: "Interim substantive testing",
  6: "Walkthroughs (year-end processes)",
  7: "Year-end control testing",
  8: "Year-end substantive testing",
  9: "Conclusion",
  10: "Not applicable",
  11: "Execution",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "Post-interim project management",
};

export const filterAuditPhases = {
  1: "Scope & strategy",
  2: "Execution",
  3: "Conclusion",
};

export const ButtonOptions = [
  {
    label: "Edit document names Edit document names",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "Edit tasks Edit tasks ",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Create draft client requests Create draft client requests",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "Edit client requests Edit client requests",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "Edit ITGCs Edit ITGCs",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "Edit controls Edit controls",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "Create tasks (OSTs) Create tasks (OSTs)",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit time phases Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "Edit deficiencies Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 3.5,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "Draft Draft",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "Pending response Pending response",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "Received Received",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "Accepted Accepted",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "Update EY Canvas Update EY Canvas",
  priority: "Priority Priority",
  assignedToGroups: "Assigned to (group) Assigned to (group)",
  assignedToUsers: "Assigned to (user) Assigned to (user)",
  eyContacts: "EY contact EY contact",
  tags: "Tags Tags",
  timephases: "Time phases Time phases",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "Update EY Canvas Update EY Canvas",
  timePhase: "Time phase Time phase",
  taskGroup: "Task group Task group",
  tags: "Tags Tags",
  timephasename: "Time phase name Time phase name",
  startDate: "Start date Start date",
  endDate: "End date End date",
  timePhaseId: "Time phase ID Time phase ID",
  taskGroupName: "Task group name Task group name",
  auditPhase: "Audit phase Audit phase",
  groupName: "Group name Group name",
  taskGroupId: "Task group ID Task group ID",
  tagDescription: "Description Description",
  tagGroup: "Tag group Tag group",
  tagLabel: "Tag Tag",
  tagColor: "Color Color",
  tagId: "Tag ID Tag ID",
  signOff: "Sign-off Sign-off",
  signOffValue: "Sign-off value Sign-off value",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "Priority name Priority name",
    priorityTypeId: "Priority type ID Priority type ID",
  },
  assignedToGroups: {
    group: "Group Group",
    groupName: "Group name Group name",
    groupId: "Group ID Group ID",
  },
  assignedToUsers: {
    groupMember: "Group member Group member",
    name: "Name Name",
    groupName: "Group name Group name",
    userId: "User ID User ID",
    groupId: "Group ID Group ID",
  },
  eyContacts: {
    name: "Name Name",
    userId: "User ID User ID",
  },
  tags: {
    tagName: "Tag Tag",
    colorCode: "Color Color",
    engagementTagName: "Description Description",
    engagementTagID: "Tag ID Tag ID",
  },
  timephases: {
    timePhaseName: "Time phase Time phase",
    periodName: "Time phase name Time phase name",
    startDate: "Start date Start date",
    dueDate: "End date End date",
    timephaseId: "Time phase ID Time phase ID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "Normal Normal",
  },
  {
    value: 3,
    label: "High High",
  },
  {
    value: 4,
    label: "Critical Critical",
  },
];

export const taskTypeAbbreviation = {
  1: "TOC TOC",  
  2: "TOC TOC",
  3: "TOC TOC",
  4: "TOC TOC",
  5: "TOC TOC",
  6: "TOC TOC",
  7: "RT RT",
  8: "RT RT",
  9: "RT RT",
  10: "RT RT",
  11: "RT RT",
  12: "OST OST",
  13: "OST OST",
  14: "PST PST",
  15: "OSP OSP",
  16: "OSP OSP",
  17: "PSP PSP",
  18: "UDP UDP",
  19: "UDP UDP",
  20: "UDP UDP",
  21: "UDP UDP",
  22: "ACT ACT",
  23: "GT GT",
  24: "GT GT",
  25: "GT GT",
  26: "OSP OSP",
  27: "GT GT",
  28: "UDP UDP",
  29: "EDC EDC",
  30: "UDP UDP",
  31: "UDP UDP",
  32: "EDC EDC", 
  34: "RT RT",
};

export const uploadStatusLabels = {
  1: "Pending Sync Pending Sync", //pending
  2: "Offline Edited Offline Edited", //offlineEdit
  3: "Downloaded Downloaded", //downloaded
  4: "Uploaded Uploaded", //uploaded
  5: "Invalid Input Invalid Input", //invalidInput
  6: "Server Error Server Error", //serverError
  7: "Unexpected API Error Unexpected API Error", //unexpectedAPIError
  8: "Client Fetch Error Client Fetch Error", //clientFetchError
};

export const clientRequestStatusType = {
  1: "Draft Draft",
  2: "Draft Draft",
  5: "Draft Draft",
  10: "Draft Draft",
  11: "Draft Draft",
  14: "Draft Draft",
  17: "Draft Draft",
  6: "Pending response Pending response",
  9: "Pending response Pending response",
  13: "Pending response Pending response",
  16: "Pending response Pending response",
  20: "Pending response Pending response",
  21: "Pending response Pending response",
  27: "Pending response Pending response",
  7: "Received Received",
  12: "Received Received",
  15: "Received Received",
  18: "Received Received",
  19: "Received Received",
  8: "Accepted Accepted",
  28: "Accepted Accepted",
};

export const colorOptionsLabels = [
  {
    value: "Red",
    label: "Red Red",
  },
  {
    value: "Orange",
    label: "Orange Orange",
  },
  {
    value: "Teal",
    label: "Teal Teal",
  },
  {
    value: "Blue",
    label: "Blue Blue",
  },
  {
    value: "Purple",
    label: "Purple Purple",
  },
  {
    value: "Green",
    label: "Green Green",
  },
  {
    value: "Yellow",
    label: "Yellow Yellow",
  },
  {
    value: "Gray",
    label: "Gray Gray",
  },
];

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "Title (required) Title (required)",
  clientRequestDescription: "Description Description",
  AssignedToGroup: "Assigned to (group) Assigned to (group)",
  AssignedToUser: "Assigned to (user) Assigned to (user)",
  DueDate: "Due date (YYYY-MM-DD) Due date (YYYY-MM-DD)",
  eyContact: "EY contact EY contact",
  tags: "Tags Tags",
  priority: "Priority Priority",
  requestGuid: "ClientRequest GUID ClientRequest GUID",
  requestId: "ClientRequestID ClientRequestID",
  statusID: "Status ID Status ID",
  timephases: "Time phase Time phase",
  requestHash: "Request # Request #",
  requestHashSpace: "Request # Request # ",
  clientRequestTitleSpace: "Title (required)  Title (required) ",
  clientRequestDescriptionSpace: "Description Description ",
  AssignedToGroupSpace: "Assigned to (group) Assigned to (group) ",
  AssignedToUserSpace: "Assigned to (user) Assigned to (user) ",
  DueDateSpace: "Due date (YYYY-MM-DD) Due date (YYYY-MM-DD) ",
  eyContactSpace: "EY contact EY contact ",
  tagsSpace: "Tags Tags ",
  prioritySpace: "Priority Priority ",
  timephasesSpace: "Time phase Time phase ",
  requestStatusId: "Request status ID Request status ID",
  requestStatus: "Request status Request status",
};

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "Many times per day Many times per day",
  },
  {
    id: 2,
    value: 2,
    label: "Daily Daily",
  },
  {
    id: 3,
    value: 3,
    label: "Weekly Weekly",
  },
  {
    id: 4,
    value: 4,
    label: "Monthly Monthly",
  },
  {
    id: 5,
    value: 5,
    label: "Quarterly Quarterly",
  },
  {
    id: 6,
    value: 6,
    label: "Annually Annually",
  },
  {
    id: 8,
    value: 8,
    label: "Other Other",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "Effective Effective",
  },
  {
    id: 2,
    value: 2,
    label: "Ineffective Ineffective",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "Effective Effective",
  },
  {
    id: false,
    value: false,
    label: "Ineffective Ineffective",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true true",
  },
  {
    id: false,
    value: false,
    label: "false false",
  },
];

export const YesNoTypes = [
  {
    id: 1,
    value: 1,
    booleanValue: true,
    label: "Yes Yes",
  },
  {
    id: 0,
    value: 0,
    booleanValue: false,
    label: "No No",
  },
];

export const instructionSheetStaticDataControl = {
  purpose:
    "This tool can be used to bulk edit control details in EY Canvas. This tool can be used to bulk edit control details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas for this field, it can be changed but not deleted. *If a value is already specified in EY Canvas for this field, it can be changed but not deleted.",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas. This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle. Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "Time phase name Time phase name",
    additionalInstructions: "500 character limit 500 character limit",
    required: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Milestone Milestone",
    additionalInstructions:
      "Select a milestone from the drop-down list Select a milestone from the drop-down list",
    required: "Yes Yes",
  },
  {
    count: "4 4",
    fieldName: "Start date Start date",
    additionalInstructions:
      "Must be specified in YYYY-MM-DD format Must be specified in YYYY-MM-DD format",
    required: "Yes Yes",
  },
  {
    count: "5 5",
    fieldName: "End date End date",
    additionalInstructions:
      "Must be specified in YYYY-MM-DD format Must be specified in YYYY-MM-DD format",
    required: "Yes Yes",
  },
  {
    count: "6 6",
    fieldName: "Key event Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work Indicate if this milestone is a key event in the completion of audit work",
    required: "No No",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "IT application control IT application control",
  },
  {
    id: 2,
    value: 2,
    label: "IT dependent manual control IT dependent manual control",
  },
  {
    id: 3,
    value: 3,
    label: "Manual prevent Manual prevent",
  },
  {
    id: 4,
    value: 4,
    label: "Manual detect Manual detect",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the record in the list sent to EY Canvas \r\n - 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2",
    fieldName: "Control name (required) Control name (required)",
    additionalInstructions: "Control name has a 500 character limit Control name has a 500 character limit",
    required: "Yes Yes",
  },
  {
    count: "3",
    fieldName: "Frequency Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list Select a control frequency from the drop-down list",
    required: "No\u002A No\u002A",
  },
  {
    count: "4",
    fieldName: "Control type Control type",
    additionalInstructions:
      "Select a control type from the drop-down list Select a control type from the drop-down list",
    required: "No\u002A No\u002A",
  },
  {
    count: "5",
    fieldName: "Design effectiveness Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective) If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No No",
  },
  {
    count: "6",
    fieldName: "Operating effectiveness Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective) If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "No No",
  },
  {
    count: "7",
    fieldName: "Testing Testing",
    additionalInstructions: "Indicate if we plan to test this control Indicate if we plan to test this control",
    required: "No No",
  },
  {
    count: "8",
    fieldName: "Is control lower risk? Is control lower risk?",
    additionalInstructions: "Indicate if the control is lower risk Indicate if the control is lower risk",
    required: "No No",
  },
];

export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "Post-interim project management Post-interim project management",
  },
  {
    id: 3,
    value: 3,
    label: "Walkthroughs Walkthroughs",
  },
  {
    id: 4,
    value: 4,
    label: "Interim control testing Interim control testing",
  },
  {
    id: 5,
    value: 5,
    label: "Interim substantive testing Interim substantive testing",
  },
  {
    id: 6,
    value: 6,
    label: "Walkthroughs (year-end processes) Walkthroughs (year-end processes)",
  },
  {
    id: 7,
    value: 7,
    label: "Year-end control testing Year-end control testing",
  },
  {
    id: 8,
    value: 8,
    label: "Year-end substantive testing Year-end substantive testing",
  },
  {
    id: 11,
    value: 11,
    label: "Execution Execution",
  },
  {
    id: 9,
    value: 9,
    label: "Conclusion Conclusion",
  },
  {
    id: 10,
    value: 10,
    label: "N/A N/A",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process IT process",
  },
];

export const instructionSheetDataForDeficiencies = {
  purpose:
    "This tool can be used to bulk edit deficiency details in EY Canvas. This tool can be used to bulk edit deficiency details in EY Canvas.",
  guidanceHyperlink: "EY Atlas EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on evaluating control deficiencies. Refer to the EY Atlas link for additional guidance on evaluating control deficiencies.",
};

export const instructionSheetTabularDataDeficiencies = [
  {
    count: "1 1",
    fieldName: "Update EY Canvas Update EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in:\r\n- 'Yes' will include the record in the list sent to EY Canvas\r\n- 'No' will exclude the record from the list sent to EY Canvas When you click the 'Update EY Canvas' button on the add-in:\r\n- 'Yes' will include the record in the list sent to EY Canvas\r\n- 'No' will exclude the record from the list sent to EY Canvas",
    required: "Yes Yes",
  },
  {
    count: "2 2",
    fieldName: "Deficiency title Deficiency title",
    additionalInstructions:
      "Unique identifier for the deficiency (100 character limit) Unique identifier for the deficiency (100 character limit)",
    required: "Yes Yes",
  },
  {
    count: "3 3",
    fieldName: "Deficiency description Deficiency description",
    additionalInstructions:
      "Description of the control deficiency (4000 character limit) Description of the control deficiency (4000 character limit)",
    required: "Yes Yes",
  },
];
